<template>
    <div class="Arrow" :class="'Arrow--'+direction">
        <svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
             viewBox="0 0 256 256" style="enable-background:new 0 0 256 256;" xml:space="preserve">
        <g>
            <g>
                <polygon :fill=colour points="225.813,48.907 128,146.72 30.187,48.907 0,79.093 128,207.093 256,79.093"/>
            </g>
        </g>
        </svg>

    </div>
</template>

<script>
    export default {
        props: {
            colour: {
                type: String,
                default: '#ffffff'
            },
            direction: {
                type: String,
                default: 'down'
            }
        },
    }
</script>
